"use client"

import { useState, useEffect, useRef } from "react"
import EmailIcon from "@mui/icons-material/Email"
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Menu,
  MenuItem,
  Container,
  ListItemIcon,
  Badge,
  IconButton,
  ListItemText,
  List,
  ListItem,
  Avatar,
  TextField,
  InputAdornment,
  Paper,
  Typography,
} from "@mui/material"
import { Link, useNavigate } from "react-router-dom"
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Notifications as NotificationsIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  Person as PersonIcon,
  Badge as BadgeIcon,
  Phone as PhoneIcon,
  SwitchAccount as SwitchAccountIcon,
  ArrowBack as ArrowBackIcon,
  Menu as MenuIcon,
} from "@mui/icons-material"

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import img from "../assets/pulseHR-n0bg.png"
import axios from "axios"
import GoogleTranslate from './gt.jsx'
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const rolePermissions = {
  hr: ["recruitment", "employeeManagement", "employeeRequest", "leave", "attendance", "performance", "training", "payroll", "cost-center", "projectManagement", "engage", "support"],
  manager: ["recruitment", "employeeManagement", "leave", "attendance", "performance", "payroll", "projectManagement", "cost-center", "engage", "support"],
  employee: [
    "employeeManagement",
    "employeeRequest",
    "leave",
    "performance",
    "attendance",
    "payroll",
    "recruitment",
    "training",
    "projectManagement",
    "engage",
    "support"
  ],
  finance: ["payroll", "cost-center", "engage", "support"],
  finance_manager: ["payroll", "cost-center", "engage", "support"],
  "project-manager": ["projectManagement", "cost-center", "engage", "support"],
  admin: ["employeeManagement", "payroll", "cost-center", "engage", "support"]
}

const navigationItems = [
  { name: "Job Posting", path: "/job-posting", feature: "recruitment", roles: ["hr"] },
  { name: "Job View", path: "/jobview", feature: "recruitment", roles: ["hr", "manager", "employee"] },
  { name: "Job Referral", path: "/refer", feature: "recruitment", roles: ["hr", "employee"] },
  { name: "Candidate Filter", path: "/candidates", feature: "recruitment", roles: ["hr"] },
  { name: "Interview Scheduling", path: "/interview-scheduling", feature: "recruitment", roles: ["hr"] },
  { name: "Interview Status", path: "/status", feature: "recruitment", roles: ["hr"] },
  { name: "Create Offer", path: "/offer", feature: "recruitment", roles: ["hr"] },
  { name: "Offer Management", path: "/sendoffer", feature: "recruitment", roles: ["hr"] },
  { name: "Onboarding Processes", path: "/onboarding", feature: "recruitment", roles: ["hr"] },
  { name: "Onboarding List", path: "/OnboardingList", feature: "recruitment", roles: ["hr"] },
  { name: "Report", path: "/recreport", feature: "recruitment", roles: ["hr", "manager"] },
  { name: "Employee Document Upload", path: "/upload", feature: "recruitment", roles: ["employee"] },

  { name: "Add Personal Details", path: "/addpersonal", feature: "employeeManagement", roles: ["hr"] },
  { name: "Add Financial Details", path: "/addfinancial", feature: "employeeManagement", roles: ["hr"] },
  { name: "Add Roles", path: "/addrole", feature: "employeeManagement", roles: ["hr"] },
  { name: "View Personal Details", path: "/viewpersonal", feature: "employeeManagement", roles: ["hr"] },
  { name: "View Financial Details", path: "/viewfinancial", feature: "employeeManagement", roles: ["hr"] },
  { name: "View Roles", path: "/viewrole", feature: "employeeManagement", roles: ["hr"] },
  { name: "Employee Profile", path: "/employee", feature: "employeeManagement", roles: ["employee"] },
  { name: "Search Employees", path: "/search", feature: "employeeManagement", roles: ["hr"] },
  { name: "Report", path: "/empreport", feature: "employeeManagement", roles: ["hr"] },

  { name: "Bonafide", path: "/bonafied", feature: "employeeRequest", roles: ["employee"] },
  { name: "Advance Salary", path: "/advancesalary", feature: "employeeRequest", roles: ["employee"] },

  { name: "Bonafide Request List", path: "/bonafiedlist", feature: "employeeRequest", roles: ["hr"] },
  { name: "Advance Salary Request List", path: "/salaryrequest", feature: "employeeRequest", roles: ["hr"] },

  { name: "Knowledge Management", path: "/training", feature: "training", roles: ["hr"] },
  { name: "Training List", path: "/trainings", feature: "training", roles: ["hr", "manager"] },
  { name: "Add Videos", path: "/video", feature: "training", roles: ["hr"] },
  { name: "Add Test", path: "/test", feature: "training", roles: ["hr"] },
  { name: "View Training", path: "/updatetraining", feature: "training", roles: ["employee"] },

  { name: "Company Account Details", path: "/companydetails", feature: "payroll", roles: ["finance"] },
  { name: "Upload CTC Details", path: "/upload-salary", feature: "payroll", roles: ["finance"] },
  { name: "View Document", path: "/view-document", feature: "payroll", roles: ["finance"] },
  { name: "Investment Proof Approval", path: "/proofapproval", feature: "payroll", roles: ["finance"] },
  { name: "Payroll Calculation", path: "/payroll-calculation", feature: "payroll", roles: ["finance"] },
  { name: "Generate Payslip", path: "/generate-payslip", feature: "payroll", roles: ["finance"] },
  { name: "View Loss House Property", path: "/viewlossproperty", feature: "payroll", roles: ["finance"] },
  { name: "Form16 (Part A)", path: "/form16-partA", feature: "payroll", roles: ["finance"] },
  { name: "Form16 (Part B)", path: "/form16-partB", feature: "payroll", roles: ["finance"] },
  { name: "Form12BB", path: "/viewform12bb", feature: "payroll", roles: ["finance"] },
  { name: "Monthly Tax (Specific)", path: "/monthly-tax-specific", feature: "payroll", roles: ["finance"] },
  { name: "Yearly Tax (Specific)", path: "/yearly-tax-specific", feature: "payroll", roles: ["finance"] },
  { name: "Monthly Tax (All)", path: "/monthly-tax-all", feature: "payroll", roles: ["finance"] },
  { name: "Yearly Tax (All)", path: "/yearly-tax-all", feature: "payroll", roles: ["finance"] },
  { name: "Claims", path: "/viewclaims", feature: "payroll", roles: ["manager"] },
  { name: "Personal Details", path: "/personal", feature: "payroll", roles: ["employee"] },
  { name: "Flex Planner", path: "/Flexplanner", feature: "payroll", roles: ["employee"] },
  { name: "Voluntary PF", path: "/vpf", feature: "payroll", roles: ["employee"] },
  { name: "Investment Declaration", path: "/investmentdec", feature: "payroll", roles: ["employee"] },
  { name: "Loss On Property Declaration", path: "/lossproperty", feature: "payroll", roles: ["employee"] },
  { name: "Submit Investment Proof", path: "/investmentproof", feature: "payroll", roles: ["employee"] },
  { name: "Claim Reimbursement", path: "/claims", feature: "payroll", roles: ["employee"] },
  { name: "TDS & TCS", path: "/tcs", feature: "payroll", roles: ["employee"] },
  { name: "HRA Receipt Form", path: "/hrareceipt", feature: "payroll", roles: ["employee"] },
  { name: "HRA Undertaking Form", path: "/hraform", feature: "payroll", roles: ["employee"] },
  { name: "ESS", path: "/ess", feature: "payroll", roles: ["employee"] },
  { name: "ESOP Statement", path: "/esop", feature: "payroll", roles: ["employee"] },
  { name: "RISU Statement", path: "/risu", feature: "payroll", roles: ["employee"] },
  { name: "Current AGP", path: "/agp", feature: "payroll", roles: ["employee"] },
  { name: "View CTC Details", path: "/view-ctc", feature: "payroll", roles: ["employee"] },
  { name: "Submit Financial Document", path: "/submit-document", feature: "payroll", roles: ["employee"] },
  { name: "Projected Tax", path: "/projected-tax", feature: "payroll", roles: ["employee"] },
  { name: "Employee Payslip", path: "/view-payslip", feature: "payroll", roles: ["employee"] },
  { name: "Form 16", path: "/form16", feature: "payroll", roles: ["employee"] },
  { name: "Form12BB", path: "/form12bb", feature: "payroll", roles: ["employee"] },
  { name: "Claims", path: "/allowanceclaim", feature: "payroll", roles: ["employee"] },

  
  { name: "Manage Leave Requests", path: "/manager", feature: "leave", roles: ["manager"] },
  { name: "Apply for Leave", path: "/leave", feature: "leave", roles: ["employee"] },
  { name: "Report", path: "/leavereport", feature: "leave", roles: ["hr", "manager"] },

  { name: "Manual Entry", path: "/manual-entry", feature: "attendance", roles: ["employee"] },
  { name: "Attendance List", path: "/attendance", feature: "attendance", roles: ["hr", "manager"] },
  { name: "Attendance List", path: "/attendencereport", feature: "attendance", roles: ["hr", "manager"] },

  { name: "Performance Management", path: "/performance", feature: "performance", roles: ["hr", "manager"] },
  { name: "Performance Management", path: "/perreport", feature: "performance", roles: ["manager"] },
  { name: "View Performance", path: "/view", feature: "performance", roles: ["employee"] },

  { name: "Project Management", path: "/project", feature: "projectManagement", roles: ["hr", "manager", "employee","project-manager"] },
  { name: "Project Data Migration", path: "/project-migration", feature: "projectManagement", roles: ["hr", "manager", "project-manager", "product-manager", "product-owner", "cpo", "principal-project-manager", "admin"] },
  { name: "NPI Project Intake", path: "/npi-intake", feature: "projectManagement", roles: ["cpo", "principal-project-manager", "project-manager", "product-manager", "product-owner", "admin"] },
  { name: "CPO & PPM Portfolio Dashboard", path: "/cpo-ppm-dashboard", feature: "projectManagement", roles: ["cpo", "principal-project-manager", "project-manager", "product-manager", "product-owner", "admin"] },
  { name: "Resource Intelligence & Planning", path: "/resource-planning-dashboard", feature: "projectManagement", roles: ["cpo", "principal-project-manager", "project-manager", "product-manager", "product-owner", "admin", "hr"] },

  // Cost Centers
  { name: "Cost Center Dashboard", path: "/cost-center-dashboard", feature: "cost-center", roles: ["finance_manager", "finance", "hr", "admin"] },
  { name: "HR Cost Centers", path: "/hr-cost-centers", feature: "cost-center", roles: ["hr", "finance", "finance_manager", "admin"] },
  { name: "Manage Cost Centers", path: "/manage-cost-centers", feature: "cost-center", roles: ["admin", "finance", "finance_manager", "hr"] },
  { name: "Project Cost Center Dashboard", path: "/pm-cost-center-dashboard", feature: "cost-center", roles: ["manager", "project-manager"] },
  
  // Salary Authorization
  { name: "Salary Authorization", path: "/salary-disbrusement", feature: "payroll", roles: ["finance"] },
  { name: "Salary Authorization", path: "/salary-authorization-manager", feature: "payroll", roles: ["finance_manager"] },
  
  // Salary Export
  { name: "Salary Transfer", path: "/salary-export", feature: "payroll", roles: ["hr", "finance", "finance_manager", "admin"] },
  
  // Pro Forma Invoice
  { name: "Generate Pro Forma Invoice", path: "/proforma-invoice", feature: "payroll", roles: ["finance", "finance_manager"] },
  { name: "Pro Forma Invoice History", path: "/proforma-history", feature: "payroll", roles: ["finance", "finance_manager"] },
  
  // Support Tickets
  { name: "Support Center", path: "/support-center", feature: "employeeRequest", roles: ["employee"] },
  { name: "Support Tickets (Manager)", path: "/manager/support-tickets", feature: "employeeManagement", roles: ["manager", "admin"] },
  { name: "Support Tickets (HR)", path: "/hr/support-tickets", feature: "employeeManagement", roles: ["hr"] },
  { name: "Support Tickets (Finance)", path: "/finance/support-tickets", feature: "payroll", roles: ["finance", "finance_manager"] },
  
  // Form T
  { name: "Form T", path: "/form-t", feature: "payroll", roles: ["employee", "hr"] },
  { name: "Form T Approval", path: "/form-t-approval", feature: "payroll", roles: ["finance", "finance_manager"] },
  
  // Gratuity
  { name: "Gratuity Overview", path: "/gratuity-overview", feature: "payroll", roles: ["employee"] },
  { name: "Gratuity Overview Report", path: "/gratuity-overview-report", feature: "payroll", roles: ["finance", "finance_manager"] },
  
  // Additional Reports and Management
  { name: "Salary Revisions", path: "/salary-revision", feature: "payroll", roles: ["finance", "finance_manager"] },
  { name: "Gender-Wise Expenditure Report", path: "/expenditure-report", feature: "payroll", roles: ["finance", "finance_manager"] },
  { name: "Holiday Calendar", path: "/holiday", feature: "leave", roles: ["employee", "manager"] },
  { name: "Holiday Management", path: "/holidaydetails", feature: "leave", roles: ["hr"] },
  { name: "Appraisal Cycle (Manager)", path: "/appraisal-cycle-manager", feature: "performance", roles: ["manager"] },
  { name: "Appraisal Cycle (HR)", path: "/appraisal-cycle-hr", feature: "performance", roles: ["hr"] },
  { name: "Self Appraisal", path: "/self-appraisal-cycle", feature: "performance", roles: ["employee"] },
  { name: "Experience Letter Request", path: "/experience-letter", feature: "employeeRequest", roles: ["employee"] },
  { name: "Experience Letter Requests (HR)", path: "/experience-letter-request", feature: "employeeRequest", roles: ["hr"] },
  { name: "Company Payroll Settings", path: "/company-payroll-settings", feature: "payroll", roles: ["admin"] },

  // Engage / Connect Hub
  { name: "Milestones", path: "/engage/milestones", feature: "engage", roles: ["admin", "hr", "manager", "employee", "finance", "finance_manager", "project-manager"] },
  { name: "Social Hub", path: "/engage/feeds", feature: "engage", roles: ["admin", "hr", "manager", "employee", "finance", "finance_manager", "project-manager"] },
  { name: "Feeds", path: "/engage/feeds", feature: "engage", roles: ["admin", "hr", "manager", "employee", "finance", "finance_manager", "project-manager"] },
  { name: "Dashboard", path: "/home", feature: "engage", roles: ["hr", "manager", "employee", "finance", "finance_manager", "project-manager"] },

  // Leave & Holidays
  { name: "Leave Policies", path: "/leavepolicies", feature: "leave", roles: ["hr"] },
  { name: "Leave Prediction", path: "/leaveprediction", feature: "leave", roles: ["hr", "manager"] },

  // Attendance
  { name: "TimeSheet Approval", path: "/time-sheet-approval", feature: "attendance", roles: ["manager"] },
  { name: "Team Attendance", path: "/manager/team-attendance", feature: "attendance", roles: ["manager"] },
  { name: "Attendance Regularization (Manager)", path: "/manager-regularization-Approval", feature: "attendance", roles: ["manager"] },
  { name: "Attendance Regularization", path: "/attendance-regularization", feature: "attendance", roles: ["employee"] },
  { name: "Timesheet", path: "/timesheet", feature: "attendance", roles: ["employee"] },

  // Performance
  { name: "Team Contributions", path: "/manager/team-contributions", feature: "performance", roles: ["manager"] },

  // Recruitment
  { name: "Offer Approval", path: "/offerapproval", feature: "recruitment", roles: ["manager"] },

  // Employee Management
  { name: "Add Contractors", path: "/contract", feature: "employeeManagement", roles: ["hr", "manager"] },
  { name: "Add Contract Employee", path: "/contractemp", feature: "employeeManagement", roles: ["hr", "manager"] },
  { name: "View Contract Employees", path: "/contractlist", feature: "employeeManagement", roles: ["hr", "manager"] },
  { name: "Add Employee Details (HR)", path: "/alldetails", feature: "employeeManagement", roles: ["hr"] },
  { name: "Asset Tracker (HR)", path: "/assets", feature: "employeeManagement", roles: ["hr"] },
  { name: "My Assets", path: "/my-assets", feature: "employeeManagement", roles: ["employee", "manager"] },
  { name: "Attrition Dashboard", path: "/attrition", feature: "employeeManagement", roles: ["hr"] },
  { name: "Offboarding", path: "/offboarding", feature: "employeeManagement", roles: ["hr", "employee"] },
  { name: "Arrears", path: "/employee-payment", feature: "payroll", roles: ["finance", "finance_manager"] }
]

const Navbar = ({ onUpgradeClick, currentSubscription, onSubscriptionUpdate, sidebaropen, setSidebarOpen }) => {
  const navigate = useNavigate()
  const token = localStorage.getItem("token")
  const userRole = localStorage.getItem("role")?.toLowerCase()
  const isLoggedIn = !!token
  const role = userRole || null

  // Subscription state for Navbar
  const [isAdminUser, setIsAdminUser] = useState(false)
  const [subscription, setSubscription] = useState(null)

  const checkAdminRole = () => {
    const token = localStorage.getItem("token")
    if (!token) return false
    const storedRole = localStorage.getItem("role")
    if (storedRole && storedRole.toLowerCase() === "admin") return true
    try {
      const payload = JSON.parse(atob(token.split(".")[1]))
      return payload?.role?.toLowerCase() === "admin"
    } catch (e) {
      return false
    }
  }

  const readInitialSubscription = () => {
    if (currentSubscription) return currentSubscription
    const storedSub = localStorage.getItem("subscription")
    if (storedSub) {
      try {
        return JSON.parse(storedSub)
      } catch (e) {}
    }
    const storedUser = localStorage.getItem("user")
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser)
        if (user.subscription) return user.subscription
      } catch (e) {}
    }
    return null
  }

  const fetchLatestSubscription = async () => {
    try {
      const token = localStorage.getItem("token")
      if (!token) return
      const res = await axios.get(`${API_URL}/api/subscription/status`, {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 6000
      })
      if (res.data) {
        const subData = res.data.subscription || {
          status: res.data.is_expired ? "EXPIRED" : "ACTIVE",
          days_remaining: res.data.days_remaining
        }
        if (res.data.days_remaining !== undefined && subData.days_remaining === undefined) {
          subData.days_remaining = res.data.days_remaining
        }
        setSubscription(subData)
        localStorage.setItem("subscription", JSON.stringify(subData))
        if (onSubscriptionUpdate) {
          onSubscriptionUpdate(subData)
        }
      }
    } catch (err) {}
  }

  useEffect(() => {
    const admin = checkAdminRole()
    setIsAdminUser(admin)
    if (admin) {
      const sub = readInitialSubscription()
      if (sub) setSubscription(sub)
      fetchLatestSubscription()
    } else {
      setSubscription(null)
    }
  }, [token, role, currentSubscription])

  useEffect(() => {
    const handleAuthChange = () => {
      const admin = checkAdminRole()
      setIsAdminUser(admin)
      if (admin) {
        const sub = readInitialSubscription()
        setSubscription(sub)
        fetchLatestSubscription()
      } else {
        setSubscription(null)
      }
    }

    window.addEventListener("storage", handleAuthChange)
    window.addEventListener("authChange", handleAuthChange)

    return () => {
      window.removeEventListener("storage", handleAuthChange)
      window.removeEventListener("authChange", handleAuthChange)
    }
  }, [])

  const [menuAnchor, setMenuAnchor] = useState(null)
  const [profileAnchor, setProfileAnchor] = useState(null)
  const [employeeData, setEmployeeData] = useState({
    employee_id: "",
    full_name: "",
    phone_number: "",
    company_email: "",
    personalPhoto: null,
    originalRole: "",
    loginAsEmployee: false,
  })
  const [employeeManagementAnchor, setEmployeeManagementAnchor] = useState(null)
  const [addEmployeeAnchor, setAddEmployeeAnchor] = useState(null)
  const [viewEmployeeAnchor, setViewEmployeeAnchor] = useState(null)
  const [payrollAnchor, setPayrollAnchor] = useState(null)
  const [employeeRequestAnchor, setEmployeeRequestAnchor] = useState(null)
  const [leaveAnchor, setLeaveAnchor] = useState(null)
  const [trainingAnchor, setTrainingAnchor] = useState(null)
  const [taxAnchor, setTaxAnchor] = useState(null)
  const [performanceAnchor, setPerformanceAnchor] = useState(null)
  const [notifications, setNotifications] = useState([])
  const [notificationAnchor, setNotificationAnchor] = useState(null)
  const [attendanceAnchor, setAttendanceAnchor] = useState(null)
  const [form16, setform16] = useState(null)
  const [onlyEmployeeAnchor, setOnlyEmployeeAnchor] = useState(null)
  const [projectAnchor, setProjectAnchor] = useState(null)
  const [showSearchBox, setShowSearchBox] = useState(false)
  const [form16Anchor, setForm16Anchor] = useState(null)
  const [transactionsAnchor, setTransactionsAnchor] = useState(null)
  const [financialAnchor, setFinancialAnchor] = useState(null)
  const [badgeAnchor, setBadgeAnchor] = useState(null)
  const [contractorsAnchor, setContractorsAnchor] = useState(null)
  const [projectsAnchor, setProjectsAnchor] = useState(null)
  const [activeProjectsAnchor, setActiveProjectsAnchor] = useState(null)
  const [sprintAnchor, setSprintAnchor] = useState(null)
  const [teamAnchor, setTeamAnchor] = useState(null)
  const [selectedProject, setSelectedProject] = useState(null)
  const [searchValue, setSearchValue] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const [showSearchResults, setShowSearchResults] = useState(false)
  const searchRef = useRef(null)
  const [salaryPayslipAnchor, setSalaryPayslipAnchor] = useState(null)
  const [proofApprovalsAnchor, setProofApprovalsAnchor] = useState(null)
  const [formsAnchor, setFormsAnchor] = useState(null)
  const [taxReportsAnchor, setTaxReportsAnchor] = useState(null)
  const [projectListAnchor, setProjectListAnchor] = useState(null)
  const [selectedProjectMenuAnchor, setSelectedProjectMenuAnchor] = useState(null)
  const [projects, setProjects] = useState([])
  const [isLoggedAsEmployee, setIsLoggedAsEmployee] = useState(false)
  const [originalRoleName, setOriginalRoleName] = useState("")

  const handleMenuOpen = (event, setter) => setter(event.currentTarget)

  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }

      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;
      const response = await axios.get(`${API_URL}/api/notifications`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
      return response.data.notifications || []
    } catch (error) {
      //console.error("Error fetching notifications:", error)
      return []
    }
  }

  const markNotificationAsRead = async (notificationId) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }

      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;
      await axios.put(
        `${API_URL}/api/notifications/${notificationId}/read`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        },
      )
    } catch (error) {
      //console.error("Error marking notification as read:", error)
    }
  }

  useEffect(() => {
    const currentProject = localStorage.getItem("selectedProject")
    if (currentProject) {
      setSelectedProject(JSON.parse(currentProject))
    }
  }, [])

  const handleProjectSelection = (project) => {
    setSelectedProject(project)
    localStorage.setItem("selectedProject", JSON.stringify(project))
  }

  // Parse token to check login mode
  useEffect(() => {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const isEmployeeMode = payload.loginAsEmployee === true;
        const originalRole = payload.originalRole || "";

        setIsLoggedAsEmployee(isEmployeeMode);
        setOriginalRoleName(originalRole);

        // Update role display name
        const roleDisplay = isEmployeeMode ? "employee" : (payload.role || role);
        localStorage.setItem("role", roleDisplay);

      } catch (error) {
        //console.error("Error parsing token:", error);
      }
    }
  }, [token, role]);


  useEffect(() => {
    const validateEmployeeAccess = async () => {
      if (!token) return;

      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const role = payload.role?.toLowerCase();
        const company_id = payload.company_id;

        // Skip validation for admin
        if (role === 'admin') {
          return;
        }

        // For non-admin users, validate employee_id exists
        const response = await axios.get(`${API_URL}/api/user/current?company_id=${company_id}`, {
     
          withCredentials: true
        });

        if (!response.data || !response.data.employee_id) {
          handleLogout();
        }

      } catch (error) {
        //console.error("Error validating employee access:", error);
        // For non-admin, logout on error
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.role?.toLowerCase() !== 'admin') {
          alert('Session Expired! Please Login again.')

          handleLogout();
        }
      }
    };

    validateEmployeeAccess();
  }, [token]);
  useEffect(() => {
    const updateNotifications = async () => {
      if (!token) return
      const userNotifications = await fetchNotifications()
      setNotifications(userNotifications)
    }
    // Add this new useEffect after the existing useEffect that handles token parsing
    // Run when token changes

    updateNotifications()
    const interval = setInterval(updateNotifications, 30000)

    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearchResults(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      clearInterval(interval)
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [token])

  useEffect(() => {
    if (searchValue.trim() === "") {
      setSearchResults([])
      setShowSearchResults(false)
      return
    }

    // Get effective role for permission checking
    const effectiveRole = isLoggedAsEmployee ? "employee" : role;

    const filtered = navigationItems.filter((item) => {
      // If item explicitly has the role, use it
      let isRoleAllowed = item.roles.includes(effectiveRole);
      
      // If not, and user is finance_manager, fall back to items that have "finance" but NOT "finance_manager"
      // to avoid duplicate search results for items that have overridden paths for finance_manager
      if (!isRoleAllowed && effectiveRole === "finance_manager") {
        isRoleAllowed = item.roles.includes("finance") && 
          !navigationItems.some(nav => nav.name === item.name && nav.roles.includes("finance_manager"));
      }

      const matchesSearch = item.name.toLowerCase().includes(searchValue.toLowerCase())
      return isRoleAllowed && matchesSearch
    })

    setSearchResults(filtered)
    setShowSearchResults(true)
  }, [searchValue, role, isLoggedAsEmployee])

  const handleNotificationClick = async (notificationId) => {
    await markNotificationAsRead(notificationId)
    const updated = notifications.map((n) => (n.id === notificationId ? { ...n, read: true } : n))
    setNotifications(updated)
  }

  const fetchEmployeeData = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }

      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;
      const userRole = payload.role?.toLowerCase();


      // FOR NON-ADMIN USERS: Check if employee_id exists
      if (userRole !== 'admin') {
        try {
          const userResponse = await axios.get(`${API_URL}/api/user/current?company_id=${company_id}`, {
    
            withCredentials: true
          });


          // If employee_id is missing, force logout
          if (!userResponse.data || !userResponse.data.employee_id) {
            handleLogout();
            return;
          }


        } catch (err) {
          //console.error("Error fetching current user:", err);
          // If API fails for non-admin, logout for safety
          if (userRole !== 'admin') {
            alert("Session Expired! Please Login again.")
            handleLogout();
            return;
          }
        }
      }

      // Continue with existing employee profile fetch
      const response = await axios.get(`${API_URL}/api/employee/employeeprofile`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })


      if (response.data.success) {
        // This check can stay as is
        if (!response.data.data.employee_id) {
          handleLogout()
          return
        }

        const employeeInfo = {
          employee_id: response.data.data.employee_id,
full_name: `${response.data.data.firstName ?? ""} ${response.data.data.lastName ?? ""}`.trim(),
          phone_number: response.data.data.phone_number,
          company_email: response.data.data.company_email,
          personalPhoto: response.data.data.personalPhoto,
          originalRole: payload.originalRole || "",
          loginAsEmployee: payload.loginAsEmployee || false,
        }

        setEmployeeData(employeeInfo)
      }
    } catch (error) {
      //console.error("Error fetching employee data:", error)
      // Only logout if it's a 401 and NOT an admin
      // Admins often don't have an employee profile record
      if (error.response?.status === 401 && userRole !== "admin") {
        handleLogout()
      }
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      if (!isLoggedIn || !token) return;

      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.role?.toLowerCase() === 'admin') {
          
          await fetchEmployeeData();
        } else {
          const company_id = payload.company_id;
          const userResponse = await axios.get(`${API_URL}/api/user/current?company_id=${company_id}`, {
      
            withCredentials: true
          });

          if (userResponse.data && userResponse.data.employee_id) {
            await fetchEmployeeData();
          } else {
            alert('Session Expired! Please Login again.');
            handleLogout();
          }
        }
      } catch (error) {
        //console.error("Error in fetchData:", error);
        alert('Session Expired! Please Login again.');
        handleLogout();
      }
    };

    fetchData();
  }, [isLoggedIn, token]);

  const handleCloseMenus = () => {
    setMenuAnchor(null)
    setProfileAnchor(null)
    setEmployeeManagementAnchor(null)
    setAddEmployeeAnchor(null)
    setViewEmployeeAnchor(null)
    setPayrollAnchor(null)
    setEmployeeRequestAnchor(null)
    setLeaveAnchor(null)
    setTrainingAnchor(null)
    setTaxAnchor(null)
    setPerformanceAnchor(null)
    setform16(null)
    setAttendanceAnchor(null)
    setForm16Anchor(null)
    setTransactionsAnchor(null)
    setFinancialAnchor(null)
    setProjectAnchor(null)
    setContractorsAnchor(null)
    setProjectsAnchor(null)
    setActiveProjectsAnchor(null)
    setSprintAnchor(null)
    setTeamAnchor(null)
    setNotificationAnchor(null)
    setBadgeAnchor(null)
    setOnlyEmployeeAnchor(null)
    setSalaryPayslipAnchor(null)
    setProofApprovalsAnchor(null)
    setFormsAnchor(null)
    setTaxReportsAnchor(null)
    setProjectAnchor(null)
    setProjectsAnchor(null)
    setProjectListAnchor(null)
    setSelectedProjectMenuAnchor(null)
    setActiveProjectsAnchor(null)
    setSprintAnchor(null)
    setTeamAnchor(null)
  }

  const handleLogout = () => {
    navigate("/")
    localStorage.removeItem("token")
    localStorage.removeItem("role")
    localStorage.removeItem("user")
    localStorage.removeItem("subscription")
    localStorage.removeItem("tenant_id")
    window.dispatchEvent(new Event("storage"))
    window.dispatchEvent(new CustomEvent("authChange", { detail: null }))
  }

  // Handle switch to employee role
  const handleSwitchToEmployee = async () => {
    try {
      setProfileAnchor(null);

      const response = await axios.post(
        `${API_URL}/api/dualLogin/switch-to-employee`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", response.data.user.role);

        // Show success message
        alert("Switched to employee view successfully!");

        // Reload to update navbar and permissions
        window.location.reload();
        navigate('/home')

      }
    } catch (error) {
      //console.error("Error switching to employee role:", error);
      alert(error.response?.data?.message || "Failed to switch to employee role");
    }
  };

  // Handle switch back to original role
  const handleSwitchBackToOriginal = async () => {
    try {
      setProfileAnchor(null);

      const response = await axios.post(
        `${API_URL}/api/dualLogin/switch-back`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", response.data.user.role);

        // Show success message
        alert("Switched back to your original role!");

        // Reload to update navbar and permissions
        window.location.reload();
        navigate('/home')
      }
    } catch (error) {
      //console.error("Error switching back:", error);
      alert(error.response?.data?.message || "Failed to switch back to original role");
    }
  };

  const handleNavigation = (path, feature) => {
    handleCloseMenus()
    setShowSearchResults(false)
    setSearchValue("")
    setShowSearchBox(false)
    const currentToken = localStorage.getItem("token")
    const currentRole = localStorage.getItem("role")?.toLowerCase()

    if (!currentToken) {
      localStorage.setItem("redirectPath", path)
      localStorage.setItem("requiredFeature", feature)
      navigate("/login")
    } else {
      // Get current login mode from token
      let isCurrentlyEmployee = false;
      try {
        const payload = JSON.parse(atob(currentToken.split('.')[1]));
        isCurrentlyEmployee = payload.loginAsEmployee === true;
      } catch (error) {
        //console.error("Error parsing token:", error);
      }

      // Use employee permissions if logged in as employee
      const effectiveRole = isCurrentlyEmployee ? "employee" : currentRole;
      const allowedFeatures = rolePermissions[effectiveRole] || [];

      if (allowedFeatures.includes(feature)) {
        navigate(path)
      } else {
        alert("You don't have access to this feature!");
      }
    }
  }

  const handleSearchResultClick = (item) => {
    handleNavigation(item.path, item.feature)
  }

  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setShowSearchResults(false)
      setShowSearchBox(false)
    }
  }

  const clearSearch = () => {
    setSearchValue("")
    setShowSearchResults(false)
    setShowSearchBox(false)
  }

  const isManager = role === "manager" || role === "hr"
  const isHR = role === "hr"
  const isEmployee = role === "employee"

  const getImageUrl = (personalPhoto) => {
    if (!personalPhoto || personalPhoto.trim() === "") {
      return null
    }

    const photoPath = personalPhoto.trim()
    return photoPath.startsWith("http") ? photoPath : `${API_URL}/uploads/${photoPath.replace(/^\/+/g, "")}`
  }

  // Check if user can switch to employee role
  const canSwitchToEmployee = ["hr", "manager", "finance", "finance_manager", 'project-manager'].includes(originalRoleName || role) && !isLoggedAsEmployee;

  // Get role display name with mode indicator
  const getRoleDisplayName = () => {
    if (isLoggedAsEmployee) {
      return `Employee (Viewing as)`;
    }
    return role ? role.charAt(0).toUpperCase() + role.slice(1) : "";
  };

  const handleLogoClick = () => {
    const currentToken = localStorage.getItem("token");
    if (currentToken) {
      navigate("/home");
    } else {
      navigate("/");
    }
  };

  return (
    <AppBar position="sticky" sx={{ bgcolor: "white", boxShadow: '0 2px 4px rgba(0,0,0,0.08)', top: 0, zIndex: 1100 }}>
      <Container maxWidth="xl" sx={{ px: 1 }}>
        <Toolbar disableGutters sx={{ minHeight: "64px", px: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          {/* Left: Logo */}
          <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0, mr: 2 }}>
            {isLoggedIn && (
              <IconButton
                onClick={() => setSidebarOpen && setSidebarOpen(!sidebaropen)}
                sx={{ display: { xs: "flex", md: "none" }, mr: 1, color: "black" }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <img
              src={img || "/placeholder.svg"}
              alt="PulseHr"
              style={{ height: "46px", width: "auto", cursor: "pointer" }}
              onClick={handleLogoClick}
            />
          </Box>

          {/* Center: Search Box */}
          <Box
            ref={searchRef}
            sx={{
              position: "relative",
              width: { xs: "100px", sm: "250px", md: "460px" },
              flexShrink: 1,
              mr: "auto"
            }}
          >
            <TextField
              size="small"
            
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" sx={{ color: "#64748b" }} />
                  </InputAdornment>
                ),
                endAdornment: searchValue && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={clearSearch}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
                sx: { borderRadius: "10px", height: "38px" },
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  bgcolor: "#f5f5f5",
                  borderRadius: "10px",
                  border: 'none',
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.12)",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.06)",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#1976d2",
                    borderWidth: '1.5px',
                  },
                },
              }}
            />

            {showSearchResults && searchResults.length > 0 && (
              <Paper
                sx={{
                  position: "absolute",
                  top: "105%",
                  left: 0,
                  width: "100%",
                  maxHeight: "300px",
                  overflow: "auto",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                  borderRadius: "10px",
                  zIndex: 2000,
                }}
              >
                <List dense>
                  {searchResults.map((item, index) => (
                    <ListItem
                      key={index}
                      button
                      onClick={() => handleSearchResultClick(item)}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(178, 216, 233, 0.3)",
                        },
                      }}
                    >
                      <ListItemText primary={item.name} secondary={`${item.feature} feature`} />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )}

            {showSearchResults && searchValue && searchResults.length === 0 && (
              <Paper
                sx={{
                  position: "absolute",
                  top: "105%",
                  left: 0,
                  width: "100%",
                  mt: 0.5,
                  p: 1.5,
                  borderRadius: "10px",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                  zIndex: 2000
                }}
              >
                <ListItemText primary="No results found" />
              </Paper>
            )}
          </Box>

          {/* Right Action Items */}
          <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 0.5, sm: 1.5 }, flexShrink: 0 }}>

            {/* Navbar Upgrade Pill matching screenshot */}
            {isAdminUser && (
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  alignItems: "center",
                  gap: 1,
                  background: subscription?.status === "EXPIRED"
                    ? "rgba(239, 68, 68, 0.08)"
                    : "#1e40af",
                  border: subscription?.status === "EXPIRED"
                    ? "1px solid rgba(239, 68, 68, 0.35)"
                    : "none",
                  borderRadius: "24px",
                  py: "3px",
                  pl: subscription?.days_remaining !== undefined && subscription?.days_remaining !== null ? 1.5 : 0.6,
                  pr: "4px",
                  boxShadow: "0 2px 6px rgba(30, 64, 175, 0.25)",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    boxShadow: "0 4px 10px rgba(30, 64, 175, 0.35)"
                  }
                }}
              >
                {subscription?.status === "EXPIRED" ? (
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      color: "#dc2626",
                      fontSize: "0.8rem",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      whiteSpace: "nowrap"
                    }}
                  >
                    <span>⚠️</span>
                    <span>{subscription?.status === "TRIAL" ? "Trial Expired" : "Subscription Expired"}</span>
                  </Typography>
                ) : (subscription?.status === "GRACE" || subscription?.is_grace) ? (
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      color: "#fbbf24",
                      fontSize: "0.8rem",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      whiteSpace: "nowrap"
                    }}
                  >
                    <span style={{ fontSize: "0.85rem" }}>⚠️</span>
                    <span>
                      Grace: <strong>{subscription.grace_days_remaining ?? subscription.days_remaining ?? 15}d</strong> left
                    </span>
                  </Typography>
                ) : (subscription?.status === "TRIAL" || subscription?.is_trial) ? (
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      color: "#fde047",
                      fontSize: "0.8rem",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      whiteSpace: "nowrap"
                    }}
                  >
                    <span style={{ fontSize: "0.85rem" }}>⏳</span>
                    <span>
                      Trial: <strong>{subscription.days_remaining ?? 0}d</strong> left
                    </span>
                  </Typography>
                ) : subscription?.status === "ACTIVE" || subscription?.plan_name ? (
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      color: "#86efac",
                      fontSize: "0.8rem",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      whiteSpace: "nowrap"
                    }}
                  >
                    <span style={{ fontSize: "0.85rem" }}>✨</span>
                    <span>
                      {subscription.plan_name || "Active Plan"}
                      {subscription.days_remaining !== undefined && subscription.days_remaining !== null
                        ? ` (${subscription.days_remaining}d)`
                        : ""}
                    </span>
                  </Typography>
                ) : null}

                <Button
                  onClick={onUpgradeClick}
                  size="small"
                  variant="contained"
                  sx={{
                    background: subscription?.status === "EXPIRED"
                      ? "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)"
                      : (subscription?.status === "GRACE" || subscription?.is_grace)
                      ? "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
                      : "#f59e0b",
                    color: subscription?.status === "EXPIRED" ? "#ffffff" : "#000000",
                    fontWeight: 800,
                    fontSize: "0.72rem",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                    borderRadius: "16px",
                    px: 1.5,
                    py: 0.3,
                    minHeight: "24px",
                    whiteSpace: "nowrap",
                    boxShadow: subscription?.status === "EXPIRED"
                      ? "0 2px 6px rgba(220, 38, 38, 0.3)"
                      : (subscription?.status === "GRACE" || subscription?.is_grace)
                      ? "0 2px 6px rgba(217, 119, 6, 0.35)"
                      : "none",
                    "&:hover": {
                      background: subscription?.status === "EXPIRED"
                        ? "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)"
                        : (subscription?.status === "GRACE" || subscription?.is_grace)
                        ? "linear-gradient(135deg, #d97706 0%, #b45309 100%)"
                        : "#fbbf24",
                      boxShadow: "0 2px 6px rgba(245, 158, 11, 0.4)",
                      transform: "translateY(-1px)"
                    },
                    transition: "all 0.15s ease-in-out"
                  }}
                >
                  {subscription?.status === "EXPIRED"
                    ? "UPGRADE NOW"
                    : (subscription?.status === "GRACE" || subscription?.is_grace)
                    ? "RENEW NOW"
                    : "UPGRADE"}
                </Button>
              </Box>
            )}

            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              <GoogleTranslate />
            </Box>



            {/* Notifications */}
            <IconButton
              color="inherit"
              onClick={(e) => {
                if (isLoggedIn && notifications.length > 0) {
                  setNotificationAnchor(e.currentTarget)
                }
              }}
              sx={{

                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.04)'
                }
              }}
            >
              <Badge badgeContent={isLoggedIn ? notifications?.filter((n) => !n.read).length : 0} color="error">
                <NotificationsIcon sx={{ color: "#333", fontSize: '1.5rem' }} />
              </Badge>
            </IconButton>

            {isLoggedIn && (
              <Menu
                anchorEl={notificationAnchor}
                open={Boolean(notificationAnchor)}
                onClose={() => setNotificationAnchor(null)}
              >
                <List sx={{ width: 300 }}>
                  {notifications.length > 0 ? (
                    notifications.map((notification) => (
                      <ListItem
                        key={notification.id}
                        button
                        onClick={() => {
                          handleNotificationClick(notification.id)
                          setNotificationAnchor(null)
                          navigate(notification.link)
                        }}
                      >
                        <ListItemIcon>
                          <Avatar sx={{ bgcolor: "primary.main" }}>
                            <NotificationsIcon />
                          </Avatar>
                        </ListItemIcon>
                        <ListItemText
                          primary={notification.message}
                          secondary={new Date(notification.createdAt).toLocaleString()}
                          sx={{
                            "& .MuiListItemText-primary": {
                              fontWeight: notification.read ? 400 : 600,
                              color: notification.read ? "text.secondary" : "text.primary",
                            },
                          }}
                        />
                      </ListItem>
                    ))
                  ) : (
                    <ListItem>
                      <ListItemText primary="No new notifications" />
                    </ListItem>
                  )}
                </List>
              </Menu>
            )}

            {/* User Profile Section */}
            {isLoggedIn ? (
              <Box sx={{ position: "relative" }}>
                <Box
                  onClick={(e) => {
                    setProfileAnchor(e.currentTarget)
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    right: 90,
                    cursor: "pointer",
                    padding: "8px 12px",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <Avatar
                    sx={{
                      width: 36,
                      height: 36,
                      bgcolor: "#1976d2",
                      fontSize: "0.9rem",
                      fontWeight: 600,
                    }}
                    src={getImageUrl(employeeData?.personalPhoto)}
                    onError={(e) => {
                      e.target.onerror = null
                      e.target.src = ""
                    }}
                  >
                    {(!employeeData?.personalPhoto || !getImageUrl(employeeData?.personalPhoto)) &&
                      (employeeData?.full_name
                        ? employeeData.full_name
                          .split(" ")
                          .map((name) => name[0])
                          .join("")
                          .toUpperCase()
                        : "U")}
                  </Avatar>

                  {/* 👇 Full Name beside avatar */}
                  <Typography
                    variant="subtitle2"
                    sx={{
                      display: { xs: "none", md: "block" },
                      fontWeight: 600,
                      color: "#333",
                      textTransform: "capitalize",
                    }}
                  >
                    {employeeData?.full_name || "User"}
                  </Typography>
                </Box>

                {/* Profile Menu */}
                <Menu
                  anchorEl={profileAnchor}
                  open={Boolean(profileAnchor)}
                  onClose={() => setProfileAnchor(null)}
                  PaperProps={{
                    sx: {
                      mt: 1,
                      borderRadius: 2,
                      minWidth: 200,
                      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  <Box sx={{ py: 1, width: "300px" }}>
                    {/* Profile Header */}
                    <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid #f0f0f0" }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Avatar
                          sx={{
                            width: 40,
                            height: 40,
                            bgcolor: "#1976d2",
                            fontSize: "1rem",
                            fontWeight: 600,
                          }}
                          src={getImageUrl(employeeData?.personalPhoto)}
                          onError={(e) => {
                            e.target.onerror = null
                            e.target.src = ""
                          }}
                        >
                          {(!employeeData?.personalPhoto || !getImageUrl(employeeData?.personalPhoto)) &&
                            (employeeData?.full_name
                              ? employeeData.full_name
                                .split(" ")
                                .map((name) => name[0])
                                .join("")
                                .toUpperCase()
                              : "U")}
                        </Avatar>
                        <Box>
                          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#333" }}>
                            {employeeData?.full_name || "User"}
                          </Typography>
                          {role !== 'admin' && (
                            <Typography variant="caption" sx={{ color: "#666" }}>
                              {employeeData?.employee_id || "Employee"}
                            </Typography>
                          )}
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                            <Box sx={{
                              padding: '2px 8px',
                              borderRadius: '12px',
                              backgroundColor: isLoggedAsEmployee ? '#e3f2fd' : '#f3e5f5',
                              display: 'inline-flex',
                              alignItems: 'center',
                            }}>
                              <Typography variant="caption" sx={{
                                fontWeight: 600,
                                color: isLoggedAsEmployee ? '#1976d2' : '#7b1fa2',
                                fontSize: '0.7rem',
                              }}>
                                {isLoggedAsEmployee ? 'Employee View' : getRoleDisplayName()}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>

                    {/* Profile Details */}
                    <Box sx={{ p: 2 }}>
                      <List sx={{ p: 0 }}>
                        {role !== 'admin' && (
                          <ListItem sx={{ px: 0, py: 1.5 }}>
                            <ListItemIcon sx={{ minWidth: 40 }}>
                              <BadgeIcon sx={{ fontSize: "1rem", color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Employee ID"
                              secondary={employeeData?.employee_id || "N/A"}
                              primaryTypographyProps={{
                                fontSize: "0.85rem",
                                fontWeight: 500,
                                color: "#666",
                              }}
                              secondaryTypographyProps={{
                                fontSize: "0.95rem",
                                fontWeight: 600,
                                color: "#333",
                              }}
                            />
                          </ListItem>
                        )}

                        <ListItem sx={{ px: 0, py: 1.5 }}>
                          <ListItemIcon sx={{ minWidth: 40 }}>
                            <PersonIcon sx={{ fontSize: "1rem", color: "#1976d2" }} />
                          </ListItemIcon>
                          <ListItemText
                            primary="Full Name"
                            secondary={employeeData?.full_name || "N/A"}
                            primaryTypographyProps={{
                              fontSize: "0.85rem",
                              fontWeight: 500,
                              color: "#666",
                            }}
                            secondaryTypographyProps={{
                              fontSize: "0.95rem",
                              fontWeight: 600,
                              color: "#333",
                            }}
                          />
                        </ListItem>

                        {role !== 'admin' && (
                          <ListItem sx={{ px: 0, py: 1.5 }}>
                            <ListItemIcon sx={{ minWidth: 40 }}>
                              <PhoneIcon sx={{ fontSize: "1rem", color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Phone Number"
                              secondary={employeeData?.phone_number || "N/A"}
                              primaryTypographyProps={{
                                fontSize: "0.85rem",
                                fontWeight: 500,
                                color: "#666",
                              }}
                              secondaryTypographyProps={{
                                fontSize: "0.95rem",
                                fontWeight: 600,
                                color: "#333",
                              }}
                            />
                          </ListItem>
                        )}

                        {/* Role Information */}
                        {isLoggedAsEmployee && originalRoleName && (
                          <ListItem sx={{ px: 0, py: 1.5 }}>
                            <ListItemIcon sx={{ minWidth: 40 }}>
                              <SwitchAccountIcon sx={{ fontSize: "1rem", color: "#ff9800" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Original Role"
                              secondary={originalRoleName.charAt(0).toUpperCase() + originalRoleName.slice(1)}
                              primaryTypographyProps={{
                                fontSize: "0.85rem",
                                fontWeight: 500,
                                color: "#666",
                              }}
                              secondaryTypographyProps={{
                                fontSize: "0.95rem",
                                fontWeight: 600,
                                color: "#ff9800",
                              }}
                            />
                          </ListItem>
                        )}
                      </List>
                    </Box>

                    {/* Role Switching Buttons */}
                    <Box sx={{ px: 2, py: 1 }}>
                      {/* Login as Employee Button (for HR/Manager/Finance) */}
                      {canSwitchToEmployee && (
                        <MenuItem
                          onClick={handleSwitchToEmployee}
                          sx={{
                            borderRadius: 2,
                            mb: 1,
                            backgroundColor: "#1976d2",
                            color: "white",
                            fontWeight: "bold",
                            "&:hover": {
                              backgroundColor: "#1565c0",
                            },
                          }}
                        >
                          <ListItemIcon sx={{ color: "white", minWidth: 40 }}>
                            <SwitchAccountIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary="Login as Employee"
                            primaryTypographyProps={{
                              fontSize: "0.9rem",
                              fontWeight: "bold",
                            }}
                          />
                        </MenuItem>
                      )}

                      {/* Switch Back Button (when in employee mode) */}
                      {isLoggedAsEmployee && (
                        <MenuItem
                          onClick={handleSwitchBackToOriginal}
                          sx={{
                            borderRadius: 2,
                            mb: 1,
                            backgroundColor: "#4caf50",
                            color: "white",
                            fontWeight: "bold",
                            "&:hover": {
                              backgroundColor: "#388e3c",
                            },
                          }}
                        >
                          <ListItemIcon sx={{ color: "white", minWidth: 40 }}>
                            <ArrowBackIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary={`Switch Back to ${originalRoleName.charAt(0).toUpperCase() + originalRoleName.slice(1)}`}
                            primaryTypographyProps={{
                              fontSize: "0.9rem",
                              fontWeight: "bold",
                            }}
                          />
                        </MenuItem>
                      )}

                      {/* Logout Button */}
                      <MenuItem
                        onClick={() => {
                          setProfileAnchor(null);
                          handleLogout();
                        }}
                        sx={{
                          borderRadius: 2,
                          backgroundColor: "#f0f0f0",
                          color: "#333",
                          fontWeight: "bold",
                          "&:hover": {
                            backgroundColor: "#e0f0ff",
                            color: "#1976d2",
                          },
                        }}
                      >
                        <ListItemText
                          primary="Logout"
                          primaryTypographyProps={{
                            fontSize: "0.9rem",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        />
                      </MenuItem>
                    </Box>
                  </Box>
                </Menu>
              </Box>
            ) : (
              <Button color="inherit" component={Link} to="/login" sx={{ color: "black" }}>
                Login
              </Button>
            )}

          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default Navbar